// Keys of cruise-related query params that should be forwarded to the ship flow
// when present on the current page's URL.
export const CRUISE_PARAM_KEYS = [
  'o_cruise_line',
  'o_cruise_port',
  'o_cruise_itinerary',
  'd_cruise_line',
  'd_cruise_port',
  'd_cruise_itinerary',
];

/**
 * Extracts cruise-related query params from a query string or URLSearchParams.
 * Returns an object containing only the keys that are present and non-empty.
 */
export const extractCruiseParams = (search = window.location.search) => {
  const source = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search);

  return CRUISE_PARAM_KEYS.reduce((acc, key) => {
    const value = source.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {});
};

/**
 * Mutates the given URLSearchParams by appending any cruise params found on
 * the current URL (or in the provided source). Existing keys on the target
 * are not overwritten.
 */
export const applyCruiseParams = (targetParams, source) => {
  const cruiseParams = extractCruiseParams(source);
  Object.entries(cruiseParams).forEach(([key, value]) => {
    if (!targetParams.has(key)) targetParams.set(key, value);
  });
  return targetParams;
};
